import React, { Component } from 'react';
import 'react-select/dist/react-select.css';
import classNames from 'classnames';
import { Input } from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';


export default class IsActive extends Component {
  // Bad implementation, cannot set the value attribute of Input componnet to a boolean.
  render() {
    const { input } = this.props;
    const titleClass = classNames({ 'parsley-error-label': this.props.meta.touched && this.props.meta.error }, 'control-label')
    return (
      <div className="boolean-field">
        {this.props.meta.touched && this.props.meta.error && <span className="parsley-error-message">{this.props.meta.error}</span>}
        <label className={titleClass}>{this.props.labelName}</label>
        <div className="boolean-input">
          <label className="boolean">
            <Input {...input} type="radio" value={true} checked={input.value === true || input.value === 'true'}/><Translate value="yes" />
          </label>
          <label className="boolean">
            <Input {...input} type="radio" value={false} checked={input.value === false || input.value === 'false'}/><Translate value="no" />
          </label>
        </div>
      </div>
    );

    // backup copy of return in case anything goes wrong fall back to this
    // return (
    //   <div>
    //     <Row><Col sm={ 12 }>{this.props.meta.touched && this.props.meta.error && <span className="parsley-error-message">{this.props.meta.error}</span>}</Col></Row>
    //     <Row className="marginTopStyle">
    //         <label className="marginTopStyle textAlignStyle" className={titleClass}>{this.props.labelName}</label>
    //         <Col sm={ 2 }></Col>
    //         <Col sm={ 2 }>
    //             <label>
    //                  <Input {...input} type="radio" value={true} checked={input.value == true || input.value == "true" }/><Translate value="yes" />
    //             </label>
    //         </Col>
    //         <Col sm={ 2 }>
    //             <label>
    //                 <Input {...input} type="radio" value={false} checked={input.value == false || input.value == "false" }/><Translate value="no" />
    //             </label>
    //         </Col>
    //     </Row>
    //   </div>
    // )
  }
}



// WEBPACK FOOTER //
// ./master/jsx/components/Common/isActive.jsx